import { Category } from '@lib/iab/iab-vast-model';

interface ICategory {
    authority: string;
    _value: string;
}

const createCategory = ($category: ICategory): Category => {
    const category = new Category();
    category.authority = $category.authority;
    category.code = $category._value;
    return category;
};

export default createCategory;
